import { render, staticRenderFns } from "./EditDocumentationPage.vue?vue&type=template&id=0b0f5230"
import script from "./EditDocumentationPage.vue?vue&type=script&lang=js"
export * from "./EditDocumentationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports